import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';
import CKEditor from "react-ckeditor-component";
import { Levels } from '../../../../shared/utility';
import { DATATABLE_CONFIG, DROPDOWN_CONFIG, NEWS_SUBMENU_ID } from '../../../../shared/Config';
import { HASACCESS, scrollToTop } from '../../../../shared/utility';
import FooterButton from '../../../../shared/UI/FooterButton/FooterButton';
import {Toast} from 'primereact/toast';
import Messages from '../../../../shared/UI/Messages/Messages';
import * as actions from '../../../../store/actions/index';


class News extends Component {
    state = {
        selectedNews:[],
        isRelavant:false,
        LevelId: null,
        EntityID:null,
        NewsContent:'',
        type: 'add',
        NewsId: null
    }

    onChange = (evt) =>{
        var newContent = evt.editor.getData();
        this.setState({
            NewsContent: newContent
        })
    }

   
    addNews = () => {


        var data = {       
            NewsContent: this.state.NewsContent,
            LevelId: this.state.LevelId,
            EntityID : this.state.EntityID,
            IsActive : true,
            CreatedDate: new Date(),
            CreatedBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
            CompanyId : this.props.loggedUserDetail.CompanyId
        }
    

        if(this.state.type === 'edit'){
            data.NewsId = this.state.NewsId;
            data.updatedBy = (this.props.loggedUserDetail.userName) ?? 'Admin';
            data.updatedDate = new Date();
        }

        this.props.processDynamicData('CompanyNews',this.state.type,data,'Company/GetCompanyNews');

        setTimeout(() => {
            if(this.props.success !== null ){
                this.resetData();
            }
        }, 3000);
    }
       

    componentDidMount(){     
        this.props.getMasterKeywordList('Employee');

        this.getAccess = HASACCESS(NEWS_SUBMENU_ID);
        setTimeout(() => {
           this.props.getMasterKeywordList('OrgUnit');
        }, 1000);

        setTimeout(() => {
            this.props.getMasterCommonList('GetCompany');
         }, 1000);


        setTimeout(() => {
            this.props.getMasterTableList('Company/GetCompanyNews');     
        }, 3000);
    }


    receiverRender = (rowData) => {
        let levelId = rowData.levelId;
        let entityId = rowData.entityId;
        let filterData = '';

        if(parseInt(levelId) === 1){
            if(this.props.GetEmployeedropdown && this.props.GetEmployeedropdown.length > 0){
                filterData =  this.props.GetEmployeedropdown.filter(filters=>{
                                return filters.value === entityId;
                                }).reduce((arr,el)=>{
                                    return el.label;
                                },'');
            }
        }else{
            if(this.props.GetOrgUnit && this.props.GetOrgUnit.length > 0){
                filterData =  this.props.GetOrgUnit.filter(filters=>{
                                return filters.value === entityId;
                                }).reduce((arr,el)=>{
                                    return el.label;
                                },'');
            }
        }
        return filterData;
      
    }

    editItem = (rowData,type) => {
        scrollToTop();
        this.setState({type:type,NewsId:rowData.newsId,NewsContent:rowData.newsContent,LevelId:parseInt(rowData.levelId),EntityID:rowData.entityId,CompanyId:rowData.companyId,isRelavant:true})
    }

    delete = (newsId) => {
        const updatedValue = [{ DeleteID : newsId}];
        this.props.dynamicDeleteProcess('CompanyNews',updatedValue,'Company/GetCompanyNews');
    }

    actionTemplate = (rowData, column) => {
        return  <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                    <Button type="button" icon="pi pi-pencil"  className="p-button-primary" onClick={()=>this.editItem(rowData,'edit')} ></Button>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                    <Button type="button" icon="pi pi-eye"  className="p-button-secondary" onClick={()=>this.editItem(rowData,'view')} ></Button>
            }
            {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                    <Button type="button" icon="pi pi-trash"  className="p-button-danger" onClick={()=>this.delete(rowData.newsId)} ></Button>
            }
                </div>;
    }


    resetData = () => {
        this.setState({isRelavant:false,NewsContent:'',LevelId:null,EntityID:null,type:'add'})
    }

    updateDetail = (e) => {
        const { name, value} = e.target;

        if (name === "LevelId") {
            if(value !==null){
                this.setState({isRelavant:true})  
            }else{
                this.setState({isRelavant:false})  
            }
        }   

        this.setState({[name]:value});
    }
    

    render() {   


        let addAccess = true;
        let editAccess = true;

        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}


        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        let GetEmployeedropdown = [];
        if(this.props.GetEmployeedropdown && this.props.GetEmployeedropdown.length > 0){
            GetEmployeedropdown = this.props.GetEmployeedropdown;
        }

        let GetOrgUnit = [];
        if(this.props.GetOrgUnit && this.props.GetOrgUnit.length > 0){
            GetOrgUnit = this.props.GetOrgUnit;
        }

        let companyList = [];

        if(this.props.companyList && this.props.companyList.length > 0){
            companyList = this.props.companyList.map(list=>{
                return {label : list.name, value: list.id}
            })
        }
        
        let releventOption = GetEmployeedropdown;
      
        let isEnabled = (this.state.LevelId!==null) &&  (this.state.EntityID!==null) &&  (this.state.NewsContent!=='');

        var filterLevelItems = [1, 5, 6];
        let levels = Levels.filter(level=> {
            return filterLevelItems.includes(level.value);
        })
            
        let dropdownName = 'Select Employee';
        if(this.state.LevelId === 6){
            releventOption = GetOrgUnit;
            dropdownName = 'Select Organization Unit';
        }else if(this.state.LevelId === 5){
            releventOption = companyList;
            dropdownName = 'Select Company';
        }

        let tableData = []    
        if(this.props.tableLists && this.props.tableLists.length > 0){
            tableData = this.props.tableLists;
           
        }

        return (
            <div className="p-grid approvalPath">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>News Settings</h1>
               
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-6">
                            <label>Select Level<span className="requiredColor">*</span></label>
                                <div className="mt1 ">
                                <Dropdown placeholder="Select Level" name="LevelId" value={this.state.LevelId} options={levels} onChange={this.updateDetail} className="width100"  {...DROPDOWN_CONFIG}/>
                                </div>                                
                            </div>

                            { this.state.isRelavant === true &&
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label>{dropdownName}<span className="requiredColor">*</span></label>
                                <div className="mt1 ">
                                <Dropdown placeholder={dropdownName}  name="EntityID" value={this.state.EntityID} options={releventOption} onChange={this.updateDetail}  className="width100"  {...DROPDOWN_CONFIG}/>
                                </div>     

                          


                            </div>
                            }

                            {/* <div className="p-col-12  p-md-12 p-lg-6">
                            <label>News Title</label>
                                <div className="mt1 ">
                                <InputText placeholder="News Title"  style={{ width: '100%' }} name="newsTitle" value={this.state.newsTitle} onChange={(e) => this.updateDetail(e)} />
                                </div>                                
                            </div> */}

                            <div className="p-col-12 p-lg-12">
                            <label>News Content<span className="requiredColor">*</span></label>
                                <div className="mt1 ">

                                <CKEditor 
                                        activeClass="p10" 
                                        content={this.state.NewsContent} 
                                        events={{
                                            "blur": this.onBlur,
                                            "afterPaste": this.afterPaste,
                                            "change": this.onChange
                                        }}
                                        />


                                </div>                                
                            </div>
                            


                            <div className="p-col-12 p-lg-12">

                            <FooterButton  access={accessButton}  disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.addNews} reset={this.resetData}  to={""} />



                                                          
                            </div>
       
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                     
                        <DataTable ref={(el) => this.dt = el} value={tableData}
                         globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >
                                {/* <Column field="levelId" header="Level" style={{display:'none'}}/> */}
                                <Column field="entityId" header="Receiver" body={this.receiverRender}/>
                                <Column field="createdBy" header="Created By" />
                                <Column field="createdDate" header="Created Date"/>
                                <Column body={this.actionTemplate} header="Action" />
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists,
        GetEmployeedropdown : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        GetOrgUnit : (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : [],
        companyList : (state.keyword.GetCompany!==undefined) ? state.keyword.GetCompany : [],
    }
}


const mapDispatchToProps = dispatch => {
    return {
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterCommonList : (value) => dispatch(actions.getMasterCommonList(value)),
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(News);